export default (product, c) => {
	const MATCH = [
		{ key: c("vod-copy-state-4"), value: 4 },
		{ key: c("vod-copy-state-3"), value: 3 },
		{ key: c("vod-copy-state-2"), value: 2 },
		{ key: c("vod-copy-state-1"), value: 1 }
	]
	const foundMatch = MATCH.find(item => item.key == product.copy)

	if (foundMatch) {
		return foundMatch.value
	}

	return null
}
